module.exports = __webpack_public_path__ + "img/user.bbbd1675.svg";